"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureFreeOffer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _planHelper = require("../../util/planHelper");
var _Button = _interopRequireDefault(require("../Button"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _reactRedux = require("react-redux");
var _paymentSlice = require("../../redux/paymentSlice");
var _FreeOfferStyled = require("./FreeOfferStyled");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FreeOffer = function FreeOffer(_ref) {
  var onPaymentComplete = _ref.onPaymentComplete;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.payment;
    }),
    isLoading = _useSelector.loading,
    error = _useSelector.error;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.offer.offer;
    }),
    period = _useSelector2.period,
    expiresAt = _useSelector2.expiresAt,
    startTime = _useSelector2.startTime,
    offerTitle = _useSelector2.offerTitle,
    offerId = _useSelector2.offerId;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var offerType = offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0);
  var icon = period || offerType;
  var generateDescriptionForFreeOffer = function generateDescriptionForFreeOffer() {
    switch (offerType) {
      case 'S':
        {
          return "Free subscription";
        }
      case 'P':
        {
          if (!period) {
            return "Access until ".concat((0, _planHelper.dateFormat)(expiresAt, true));
          }
          return "".concat(_planHelper.periodMapper[period].accessText, " free pass");
        }
      case 'E':
        {
          return "Free event ".concat(startTime ? (0, _planHelper.dateFormat)(startTime, true) : '');
        }
      case 'R':
        {
          return "".concat(_planHelper.periodMapper[period].accessText, " free access");
        }
      case 'A':
        return 'Unlimited access';
      default:
        return '';
    }
  };
  var getAccessToFreeOffer = (0, _react.useCallback)(function () {
    dispatch((0, _paymentSlice.submitPaymentWithoutDetails)()).unwrap().then(onPaymentComplete);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.CardStyled, null, /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.SubscriptionIconStyled, {
    icon: icon
  }), /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.TitleStyled, null, t("offer-title-".concat(offerId), offerTitle)), /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.DescriptionStyled, null, generateDescriptionForFreeOffer()), /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.ButtonWrapperStyled, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    theme: "confirm",
    width: "200px",
    onClickFn: getAccessToFreeOffer,
    disabled: isLoading
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    buttonLoader: true,
    color: "#ffffff"
  }) : t('Get Access')), error && /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.ErrorMessageStyled, null, t(error))), /*#__PURE__*/_react.default.createElement(_FreeOfferStyled.SubTextStyled, null, t('Free, no additional cost'))));
};
exports.PureFreeOffer = FreeOffer;
FreeOffer.propTypes = {
  onPaymentComplete: _propTypes.default.func.isRequired
};
var _default = FreeOffer;
exports.default = _default;